import React, { FC } from 'react';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';
import styles from './hide_wrapper.module.scss';
import { useUser } from '../../user/useUser';

type Props = {
  source: string;
};

export const HideWrapper: FC<Props> = ({ children, source }) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  return accessPremium ? (
    <>{children}</>
  ) : (
    <div className={styles.hide}>
      <button
        className={styles.hidden}
        onClick={() => openRestrictedModal({ source })}
        type="button"
      >
        <MaterialIcon name="lock" className={styles.locked} />
      </button>
      {children}
    </div>
  );
};
